<template>
  <Modal :id="id" :title="title" scrollable="true" ok-title="下载" @ok="$emit('download', file)">
    <Placeholder v-if="loading" />
    <template v-else>
      <div v-if="has_preview" class="mb-4">
        <pre v-if="text" style="white-space:pre-wrap">{{ text }}</pre>
        <img v-else-if="img_dataurl" :src="img_dataurl" class="w-100 mx-auto" />
      </div>
      <div>
        <div class="ui message">
          <p class="font-bold">
          <div v-if="file">
            <p>
            文件名： {{ file.name }}
            </p>
            <p>
            文件大小： {{ bytes_to_human(file.size) }}
            </p>
            <p>
            创建时间： {{ format_time_ms(file.ctime) }}
            </p>
            <p>
            修改时间： {{ format_time_ms(file.mtime) }}
            </p>
          </div>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from './modal';
import Placeholder from './placeholder'

export default {
  name: 'FilePreviewModal',
  props: ['id'],
  components: {
    Modal,
    Placeholder,
  },
  data: function () {
    return {
      file: null,
      loading: true,
      buf: null,
      has_thumb: false,
    };
  },
  computed: {
    space() {
      return this.$store.state.space;
    },
    has_preview() {
      return this.text || this.img_dataurl;
    },
    title() {
      if (this.file) {
        return this.file.name;
      }
      return '';
    },
    text() {
      if (!this.file || !this.buf) {
        return null;
      }
      if (!this.file.name.toLowerCase().endsWith(".txt")) {
        return null;
      }
      return String.fromCharCode.apply(null, new Uint8Array(this.buf));
    },
    file_ext() {
      return this.space.path_ext(this.file.name).toLowerCase();
    },
    is_image() {
      return this.space.is_image(this.file.name);
    },
    img_dataurl() {
      if (!this.file || !this.buf) {
        console.log("no img", this.file, this.buf);
        return null;
      }
      var fn = this.file_ext;
      var fmt = null;
      if (this.has_thumb) {
        fmt = "jpeg";
      } else if (fn == "jpg" || fn == "jpeg") {
        fmt = "jpeg";
      } else if (fn == "png") {
        fmt = "png";
      } else if (fn == "gif") {
        fmt = "gif";
      }
      if (!fmt) {
        return null;
      }
      return 'data:image/' + fmt + ';base64,' + this.buf.toString('base64');
    },
  },
  methods: {
    async reload(e) {
      console.log("reload", e);
      this.file = e;
      this.loading = true;
      try {
        var pf = this.file;
        if (!pf) {
          return null;
        }
        if (this.is_image) {
          console.log("trying thumbs");
          var thumb = await this.space.fetch('/.mods/thumbs/' + pf.obj_id + ".jpg");
          if (thumb) {
            this.has_thumb = true;
            this.buf = await this.space.read_file(thumb.path);
            return;
          }
        }
        if (pf.size / 1024 > 1024) {
          return null;
        }
        this.buf = await this.space.read_file(pf.path);
        console.log("loaded", this.buf);
      } catch (e) {
        console.log(e, e.message);
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
  },
}
</script>

<style scoped>
</style>

